import styleInject from '../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Dialog-module_dialog__yCbjJ {\n  color: var(--color-neutral-800);\n}\n\n.Dialog-module_no-scroll__vLKxY {\n  overflow: hidden;\n}";
var styles = {"dialog":"Dialog-module_dialog__yCbjJ","no-scroll":"Dialog-module_no-scroll__vLKxY"};
styleInject(css_248z);

export { styles as default };
